const SPEED = 2000;
const ACC = 8000;
const DRAG = 0.1;
let destination = { x: 0, y: 0 };
let transforms = [];
let animId;
let lastTime = 0;
let initialTime = 0;
let finishAnimation = false;

export default function startStarsAnimation({ stars, origin, target, onEnd }) {
  destination = target;
  try {
    createExplosion(stars, origin, onEnd);
  } catch (e) {
    console.error(e);
    onEnd();
  }
}

function createExplosion(stars, origin, onEnd) {
  transforms = [];
  for (let star of stars) {
    const randomAngle = Math.random() * 2 * Math.PI;

    let transform;
    const starInitialSpeed = SPEED * (0.8 + Math.random() * 0.4);

    const starTransform = {
      x: origin.x,
      y: origin.y,
      vx: starInitialSpeed * Math.cos(randomAngle),
      vy: starInitialSpeed * Math.sin(randomAngle),
      ax: 0,
      ay: 0,
      scale: 1,
    };
    transforms.push(starTransform);

    star.style.opacity = 1;
    star.style.transform = `translate(${starTransform.x}px, ${starTransform.y}px)`;
  }
  if (!animId)
    animId = requestAnimationFrame((currentTime) =>
      update(currentTime, stars, onEnd)
    );
}

function update(currentTime, stars, onEnd) {
  try {
    if (lastTime === 0) {
      lastTime = currentTime;
      initialTime = currentTime;
    }
    const elapsedTime = currentTime - initialTime;
    const deltaTime = (currentTime - lastTime) / 1000;
    lastTime = currentTime;
    for (let i = 0; i < transforms.length; i++) {
      const transform = transforms[i];

      const angle = Math.atan2(
        destination.y - transform.y,
        destination.x - transform.x
      );
      transform.ax = Math.cos(angle) * ACC;
      transform.ay = Math.sin(angle) * ACC;

      transform.vx =
        transform.vx - transform.vx * DRAG + transform.ax * deltaTime;
      transform.vy =
        transform.vy - transform.vy * DRAG + transform.ay * deltaTime;

      transform.x += transform.vx * deltaTime;
      transform.y += transform.vy * deltaTime;
      transform.scale =
        elapsedTime < 0.5 ? transform.scale * 5 : transform.scale * 0.975;

      render(stars[i], transform, i);
      const distance = Math.sqrt(
        (transform.x - destination.x) ** 2 + (transform.y - destination.y) ** 2
      );
      if (distance < 10) {
        finishAnimation++;
        if (stars?.[i]?.style) {
          stars[i].style.opacity = 0;
        }
      }
    }
    if (finishAnimation >= transforms.length) {
      finishAnimation = false;
      animId = null;
      lastTime = 0;
      initialTime = 0;
      for (const star of stars) {
        if (star?.style) {
          star.style.opacity = 0;
        }
      }

      cancelAnimationFrame(animId);
      onEnd();
    } else {
      requestAnimationFrame((currentTime) => update(currentTime, stars, onEnd));
    }
  } catch (e) {
    console.error(e);
    onEnd();
  }
}

function render(star, transform) {
  if (star?.style) {
    star.style.transform = `translate(${transform.x}px, ${transform.y}px) scale(${transform.scale})`;
  }
}
